import { render, staticRenderFns } from "./singleAdministrationChildrenFirst.vue?vue&type=template&id=631689d8&scoped=true"
import script from "./singleAdministrationChildrenFirst.vue?vue&type=script&lang=js"
export * from "./singleAdministrationChildrenFirst.vue?vue&type=script&lang=js"
import style0 from "./singleAdministrationChildrenFirst.vue?vue&type=style&index=0&id=631689d8&prod&lang=less&scope=true"
import style1 from "./singleAdministrationChildrenFirst.vue?vue&type=style&index=1&id=631689d8&prod&lang=less"
import style2 from "./singleAdministrationChildrenFirst.vue?vue&type=style&index=2&id=631689d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631689d8",
  null
  
)

export default component.exports